import Fingerprint2 from 'fingerprintjs2'

const fingerPrintOptions = {
  excludes: {
    fonts: true,
    screenResolution: true,
    availableScreenResolution: true
  }
}

export default (callback) => {
  try {
    Fingerprint2.getV18(fingerPrintOptions, (fingerprint) => {
      callback(fingerprint)
    })
  } catch {
    // Something went wrong, return an undefined fingerprint
    callback(undefined)
  }
}
